import React from 'react';
import colors from '../theme/colors';
import ReactSelect, { formatDotLabel, formatDotStyles } from './ReactSelect';

export type GenericStatus = (typeof statusOptions)[number]['value'];

const statusOptions = [
  {
    value: 'ACTIVE',
    label: 'Active',
    color: colors.statusSuccess,
  },
  {
    value: 'INACTIVE',
    label: 'Inactive',
    color: colors.statusError,
  },
] as const;

export const GenericStatusPicker = ({
  value,
  isClearable,
  onChange,
  counts,
  ariaLabel,
}: {
  value?: GenericStatus;
  isClearable?: boolean;
  onChange: (value?: GenericStatus) => void;
  counts?: Record<'ALL' | GenericStatus, number>;
  ariaLabel?: string;
}) => {
  const options = counts
    ? [
        { value: undefined, label: `All (${counts.ALL})`, color: '' },
        ...statusOptions.map((option) => ({
          ...option,
          label: `${option.label} (${counts[option.value]})`,
        })),
      ]
    : statusOptions;

  return (
    <ReactSelect
      aria-label={ariaLabel}
      placeholder="status"
      isClearable={isClearable}
      value={options.find((option) => value === option.value)}
      styles={{
        multiValue: formatDotStyles,
      }}
      formatOptionLabel={formatDotLabel}
      onChange={(value) => {
        onChange(value?.value ?? undefined);
      }}
      options={options}
    />
  );
};
